import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wo-quarter-rank"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "color": "#1C1C1C",
    "line-height": "1.5rem",
    "padding": "0 2.0rem"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "padding": "0 2.0rem 0 0"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "font-weight": "normal"
  }
};
const _hoisted_7 = {
  class: "resume-container"
};
const _hoisted_8 = {
  key: 1
};
import { onMounted, ref, computed } from 'vue';
import { request } from '@/manager/net_manager';
import { ElMessage } from 'element-plus';
import store from '@/store';
export default {
  __name: 'WOQuarterRank',

  setup(__props) {
    const worldOutlook = computed(() => {
      return store.state.world_outlook ?? null;
    });
    const quarterArray = ref([]);
    const quarterRankData = computed(() => {
      if (!worldOutlook.value) return null;
      if (!store.state.world_outlook_info[worldOutlook.value.id]) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.quarter_rank_data ?? null;
    });
    onMounted(() => {
      quarterArray.value = getQuarterRange();
      getData();
    });

    const getQuarterRange = (date = new Date()) => {
      const month = date.getMonth() + 1;
      const currentQuarter = Math.ceil(month / 3);
      return [currentQuarter]; // return Array.from({length: currentQuarter}, (_, i) => `${i + 1}`)
    };

    const getData = () => {
      if (!worldOutlook.value) return;
      if (quarterRankData.value) return;
      let data = {
        'world_outlook_id': worldOutlook.value.id,
        'quarter_array': quarterArray.value
      };
      let url = 'world_outlook/get_quarter_data/';
      request(url, data, 'POST', {
        'Content-Type': 'application/json'
      }).then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.commit('update_wo_info', {
          wo_id: worldOutlook.value.id,
          key: 'quarter_rank_data',
          value: response.data
        });
      });
    };

    const sortRankData = array => {
      // console.log(JSON.stringify(array))
      return array.sort((a, b) => {
        if (parseInt(b['total_experience']) !== parseInt(a['total_experience'])) {
          return parseInt(b['total_experience']) - parseInt(a['total_experience']);
        } else if (parseInt(b['total_mvp']) !== parseInt(a['total_mvp'])) {
          return parseInt(b['total_mvp']) - parseInt(a['total_mvp']);
        } else if (parseFloat(b['total_rating']) !== parseFloat(a['total_rating'])) {
          return parseFloat(b['total_rating']) - parseFloat(a['total_rating']);
        } else {
          return 0;
        }
      });
    };

    return (_ctx, _cache) => {
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");

      const _component_el_collapse = _resolveComponent("el-collapse");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quarterArray.value.slice().reverse(), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("text", _hoisted_2, [_createElementVNode("b", null, _toDisplayString(new Date().getFullYear()) + " 第" + _toDisplayString(item) + "季度  /  选中者数据排行", 1)]), _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), quarterRankData.value && quarterRankData.value[item] && quarterRankData.value[item].length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_collapse, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortRankData(quarterRankData.value[item]), (role_item, index) => {
            return _openBlock(), _createBlock(_component_el_collapse_item, {
              key: index,
              class: "organization-item"
            }, {
              title: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("text", {
                class: _normalizeClass(['rank_position', `rank_position_${index}`])
              }, " No." + _toDisplayString(index + 1), 3), _createElementVNode("b", null, _toDisplayString(role_item.nickname), 1)]), _createElementVNode("div", _hoisted_6, "     经验成长：" + _toDisplayString(role_item.total_experience) + " " + _toDisplayString(role_item.total_mvp.toString() !== '0' ? `  /  卓越场：${role_item.total_mvp}` : '') + "   /  难度挑战分：" + _toDisplayString(role_item.total_rating), 1)])]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(role_item.resumes, (resume_item, resume_index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: resume_index,
                  class: "resume-cell"
                }, [_createElementVNode("b", null, _toDisplayString(resume_item.drama), 1), _createElementVNode("span", null, _toDisplayString(resume_item.mvp ? '(卓越)' : '') + " " + _toDisplayString(` / 经验+${resume_item.experience}`), 1), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", null, _toDisplayString(resume_item.start_date) + " ~ " + _toDisplayString(resume_item.end_date), 1)]);
              }), 128))])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 2
        }, 1024)])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[1] || (_cache[1] = [_createElementVNode("text", {
          class: "empty-data-tips"
        }, "没有检测到选中者演出数据", -1)]))])), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))]);
      }), 128))]);
    };
  }

};